// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const SEND_UPLOAD_PROGRESS_EVENT = 'sendUploadProgress';
const SEND_DOWNLOAD_PROGRESS_EVENT = 'sendDownloadProgress';
const NETWORK_ERROR_MESSAGE = 'Network Error';
const NETWORK_ERROR_CODE = 'ERR_NETWORK';
const ABORT_ERROR_MESSAGE = 'Request aborted';
const ABORT_ERROR_CODE = 'ERR_ABORTED';
const CANCELED_ERROR_MESSAGE = 'canceled';
const CANCELED_ERROR_CODE = 'ERR_CANCELED';
const CONTENT_SHA256_HEADER = 'x-amz-content-sha256';

export { ABORT_ERROR_CODE, ABORT_ERROR_MESSAGE, CANCELED_ERROR_CODE, CANCELED_ERROR_MESSAGE, CONTENT_SHA256_HEADER, NETWORK_ERROR_CODE, NETWORK_ERROR_MESSAGE, SEND_DOWNLOAD_PROGRESS_EVENT, SEND_UPLOAD_PROGRESS_EVENT };
//# sourceMappingURL=constants.mjs.map
